import {defineCustomElement} from "vue";
import {RateLimitExceeded} from "@/api/api.service.ts";
import {handleRateLimitExceeded} from "@/service/rateLimitHandler.ts";

/** Disable shadowRoot to use global styles of gravity-template */
const shadowRoot = false;

export function defineAndRegisterElement(tag: string, component: any) {
  window.customElements.define(tag, defineCustomElement(component, {
    shadowRoot,
    configureApp(app) {
      app.config.errorHandler = customErrorHandler
    }
  }))
}

function customErrorHandler(error: unknown) {
  if (error instanceof RateLimitExceeded) {
    handleRateLimitExceeded(error)
  }
}
